module.exports = __webpack_public_path__ + "static/img/2.2.e24bbe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/picture/2.2.jpg
// module id = tcEo
// module chunks = 7